<template>
  <div>
    <div>
       <div class="md:w-1/2 w-full p-1">
            <vs-input
                placeholder="Search"
                class="w-full"
                v-model="search"
                @keyup="searchFun"
                style="width: 100%"
              />
          </div>
      <!-- <pre>{{smsLogs}}</pre> -->
      <ag-grid-vue 
        ref="agGridTable"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :style="{ minHeight: smsLogs.length * 48 + 75 + 'px' }"
        :gridOptions="gridOptions"
         :defaultColDef="defaultColDef"
        :animateRows="true"
        :floatingFilter="false"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        :columnDefs="columnDefs"
        :rowData="smsLogs"
        @grid-ready="onGridReady"
        @sortChanged="sortFun"
      />
      <div class="sm:flex justify-between items-center">
        <ItemsPerTableDropdown
          tableName="sms_log_list"
          @change="(pageLimit) => smsLogPageLimitSet = pageLimit"
        />
        <pagination
          :meta="query_page"
          @page-change="handlePageChange"
          class="cstm_pagination"
          style="float: right"
        />
      </div>
    </div>
  </div>
</template>

<script>
import cellRendereImage from '@/views/pages/sms/cellrenderImage.vue'
import { AgGridVue } from 'ag-grid-vue'
import Pagination from '@/components/common/pagination'
import { smsLog } from '@/api/sms.js'
export default {
  components: {
    AgGridVue,
    Pagination,
    cellRendereImage
  },
  data () {
    return {
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
        // autoHeight: true
      },
      search:'',
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      columnDefs: [],
      smsLogs: [],
      query_page: {
        total: '',
        limit: 10,
        has_next: false,
        current_page: 1,
        next_page_url: null,
        previous_page_url: ''
      },
      smsLogPageLimitSet: null,
      gridOptions: {
        accentedSort: true
      },
      gridApi: null
    }
  },
  mounted () {
    this.columnDefs = [
      // {
      //   headerName: 'Model Name',
      //   field: 'model_name'
      // },
      // {
      //   headerName: 'Type of SMS',
      //   field: 'type_of_sms'
      // },
      // {
      //   headerName: 'Receiver',
      //   field: 'receiver'
      // },
      {
        headerName: 'Sender',
        field: 'from_user_details',
        sortable: false,
        cellRendererFramework:'cellRendereImage',
        cellRendererParams:{
          type:'from_user_details'
        }
       // valueFormatter: params => `${params.data.from_user_details != null ? params.data.from_user_details.first_name : ''}  ${params.data.from_user_details != null ? params.data.from_user_details.last_name : ''}`
      },
      {
        headerName: 'Receiver',
        field: 'to_user_details',
        sortable: false,
        cellRendererFramework:'cellRendereImage',
        cellRendererParams:{
          type:'to_user_details'
        }
        // cellRenderer:params => {
        //   let data = params.data.to_user_details.picture ? params.data.to_user_details.picture :
        //     <svg style="width: 25px; height: 25px; object-fit: contain;" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user-circle" 
        //       class="svg-inline--fa fa-user-circle fa-w-16" role="img" viewBox="0 0 496 512"><path fill="currentColor"
        //         d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"/></svg>
            
              
        //   data = `<img :src="${data}"  style="width: 25px; height: 25px; object-fit: contain;" />${params.data.to_user_details.first_name} ${params.data.to_user_details.middle_name || ''} ${params.data.to_user_details.last_name}`
        //   return data
        // }
      
      },
      {
        headerName: 'Description',
        field: 'message'
      },
      // {
      //   headerName: 'Status',
      //   field: 'status',
      //   // eslint-disable-next-line no-confusing-arrow
      //   valueFormatter: params => params.data.success_status ? '\u2713' : '\u274C'
      // },
      // {
      //   headerName: 'Error Message',
      //   field: 'error_message'
      // },
      {
        headerName: 'Date and Time',
        field: 'created_at',
        valueFormatter: params => this.$options.filters.dateFormatLocalization(params.data.created_at)
      }
    ]
  },
  watch: {
    smsLogPageLimitSet () {
      this.handlePageChange(1)
    }
  },
  methods: {
    searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async (vm) => {
      try {
        vm.handlePageChange(1)
      } catch (e) {
        console.log(e)
      }
    }, 1000),
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        this.sorting_obj.field_type = 'system'
        this.sorting_obj.attribute = sortState[0].colId
        this.sorting_obj.direction = sortState[0].sort
        this.handlePageChange()
      } catch (e) {}
    },
    async fetchSmsLog (page = 1) {
      try {
        const payload = {
          search:this.search
        }
        const res = await smsLog(this.sorting_obj, 'sms_log_list',
          payload, localStorage.getItem('customer_id'), page, this.smsLogPageLimitSet)
        this.smsLogs = res.data.data.sms_logs
        this.query_page = res.data.data.meta

        // console.log(data)
      } catch (error) {
        console.warn(error)
      }
    },
    handlePageChange (page) {
      if (!this.smsLogPageLimitSet) return
      this.fetchSmsLog(page)
    },
    onGridReady () {
      this.gridOptions.api.sizeColumnsToFit()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
